import type {SidebarExtension} from "../../layouts/app-shell/right-sidebar/types";

import {SparklesIcon} from "@project/icons-web";

import {aiAssistantMessages} from "./ai-assistant.messages";
import {AISidebar} from "./components/ai-sidebar";

export const aiAssistantExtension = {
  id: "ai-assistant",
  labelDescriptor: aiAssistantMessages.label,
  icon: <SparklesIcon />,
  panel: AISidebar,
} satisfies SidebarExtension;
